import { useCallback } from 'react';
import { serializeError } from 'serialize-error';
import { useAddGiftsToShipmentMutation, useCreateShipmentWithGiftsMutation } from '../../generated/graphql';
import { onGiftSubscriptionData } from './queries';

// Cache refresh failures must not turn committed mutations into apparent write failures.
export const useCreateShipmentWithGifts = () => {
  const [createShipmentWithGifts, data] = useCreateShipmentWithGiftsMutation();

  const createShipmentWithGiftsAndUpdateListQueries: typeof createShipmentWithGifts = useCallback(
    async (options) => {
      const response = await createShipmentWithGifts(options);
      for (const gift of response.data?.createShipmentWithGifts?.gifts?.items || []) {
        if (!gift) continue;
        try {
          await onGiftSubscriptionData(
            {
              onAnyGiftChanged: gift
            },
            {}
          );
        } catch (error) {
          console.error('Gift cache refresh failed after shipment creation', { giftId: gift.id, companyId: gift.companyId, error: serializeError(error) });
          break;
        }
      }
      return response;
    },
    [createShipmentWithGifts]
  );

  return [createShipmentWithGiftsAndUpdateListQueries, data] as ReturnType<typeof useCreateShipmentWithGiftsMutation>;
};

export const useAddGiftsToShipment = () => {
  const [addGiftsToShipment, data] = useAddGiftsToShipmentMutation();

  const addGiftsToShipmentAndUpdateListQueries: typeof addGiftsToShipment = useCallback(
    async (options) => {
      const response = await addGiftsToShipment(options);
      for (const gift of response.data?.addGiftsToShipment?.gifts?.items || []) {
        if (!gift) continue;
        try {
          await onGiftSubscriptionData(
            {
              onAnyGiftChanged: gift
            },
            {}
          );
        } catch (error) {
          console.error('Gift cache refresh failed after shipment assignment', { giftId: gift.id, companyId: gift.companyId, error: serializeError(error) });
          break;
        }
      }
      return response;
    },
    [addGiftsToShipment]
  );

  return [addGiftsToShipmentAndUpdateListQueries, data] as ReturnType<typeof useAddGiftsToShipmentMutation>;
};
